import FreeUsersTable from '../_components/free-users/page';

export default function FreeUsers() {
  return (
    <FreeUsersTable
      isApplyDefaultFilter={true}
      setIsApplyDefaultFilter={() => {}}
    />
  );
}
